import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Paper,
  Link
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import useDraggable from '../hooks/useDraggable';

function DraggablePaperComponent(props) {
  const { ref, style, handleMouseDown } = useDraggable({ resetOnClose: true, handleSelector: '#help-dialog-title' });
  return <Paper ref={ref} {...props} style={{ ...props.style, ...style }} onMouseDown={handleMouseDown} />;
}

const HelpDialog = ({ open, onClose }) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperComponent={DraggablePaperComponent} aria-labelledby="help-dialog-title">
    <DialogTitle id="help-dialog-title" style={{ cursor: 'grab' }}>Turn Assistant — Quick Guide</DialogTitle>
    <DialogContent dividers>
      <Typography variant="body2" paragraph>
        <strong>Required:</strong> Select your 2 active Pokémon (top slots) and your opponent's 2 (bottom slots), then click <em>Analyze Battle</em>.
      </Typography>
      <Typography variant="body2" paragraph>
        <strong>Optional but recommended:</strong> Add items, abilities, Tera types, moves, and status conditions to each Pokémon — every detail improves the AI's accuracy.
      </Typography>
      <Typography variant="body2" paragraph>
        <strong>Team & field context:</strong> Use <em>Select Team</em> to load your full roster — the easiest way is to import it from a Poképaste. You can also set weather, terrain, screens, or hazards via <em>Battle Conditions</em>.
      </Typography>
      <Typography variant="body2" paragraph>
        <strong>Revealing opponent Pokémon:</strong> As the battle progresses, reveal or feint your team or your opponent's team by clicking directly on the sprites or by selecting them from the team panel. The AI will factor in whatever you've revealed so far.
      </Typography>
      <Typography variant="body2" paragraph>
        <strong>Results:</strong> You'll get a win probability and the move combinations ranked by strategic impact — not raw damage, but actual battle value.
      </Typography>
      <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)', fontStyle: 'italic' }}>
        Hit <em>Reset All</em> to clear the board and start a new turn.
      </Typography>
      <Typography variant="body2" sx={{ mt: 1.5 }}>
        Need help or found a bug? Visit the{' '}
        <Link component={RouterLink} to="/contact" onClick={onClose} sx={{ color: '#90caf9', fontWeight: 'bold' }}>
          Contact page
        </Link>
        .
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} variant="outlined" color="error">
        Close
      </Button>
    </DialogActions>
  </Dialog>
);

export default HelpDialog;
